module.exports = __webpack_public_path__ + "img/541-42dfb3.png";